import axios from "axios";
import * as Sentry from "@sentry/vue";
import { apiPrefix } from "./config";

let requestQueue = [];
let authInProgress = false;

const addRequestToQueue = config =>
  new Promise((resolve, reject) => {
    requestQueue.push({
      config,
      resolve,
      reject
    });
  });

const handleQueue = token => {
  requestQueue.forEach(({ config, resolve, reject }) => {
    config.headers.Authorization = token;
    axios.request(config).then(resolve, reject);
  });
};

export const authInterceptor = async axiosInstance => {
  axiosInstance.interceptors.response.use(undefined, async err => {
    const { config, response } = err;

    if (!response) throw err;

    if (response.status === 401) {
      if (authInProgress) {
        return addRequestToQueue(config);
      }

      try {
        authInProgress = true;

        const {
          data: { accessToken }
        } = await axios.get(`${apiPrefix}/authorize`, { withCredentials: true });

        // [IE] Resets cached Kerberos auth IE8 and above
        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
          document.execCommand("ClearAuthenticationCache", "false");
        }

        const token = `Bearer ${accessToken}`;
        axiosInstance.defaults.headers.common.Authorization = token;

        handleQueue(token);

        config.headers.Authorization = token;
        return axios.request(config);
      } catch (error) {
        Sentry.captureException(error);
        error.message = 'Service is unavailable right now';
        error.response.message = 'Service is unavailable right now';
        error.response.data.message = 'Service is unavailable right now';
        throw error;
      } finally {
        requestQueue = [];
        authInProgress = false;
      }
    }

    throw response;
  });
};
